import { useQuery } from '@tanstack/react-query';

import { getActiveCampaignStatus } from '../api/status';
import type { ActiveCampaignStatusResponse } from '../types';

export function useActiveCampaignStatus(orgId: number | string | undefined) {
  return useQuery<ActiveCampaignStatusResponse>({
    queryKey: ['activeCampaignStatus', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getActiveCampaignStatus(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => {
      const { data } = query.state;
      if (!data?.connected) {
        return false;
      }
      if (data?.bulk_completed_at == null) {
        return 5000;
      }
      return 30000;
    },
  });
}
